module.exports = __webpack_public_path__ + "static/media/F-1-2-mobile.f8147fea.webp";